import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../store';
import withRouter from '../Components/Common/withRouter';
import Header from './Header';
import Alert from '../Components/Common/Alert';
import Footer from './Footer';
import InternetStatus from '../Components/Common/InternetStatus';
import FloatingOrderButton from '../Components/Common/FloatingOrderButton';
import PWAInstallBanner from '../Components/Common/PWAInstallBanner';
import ShopLocationBanner from '../Components/Common/ShopLocationBanner';
import { fetchDraftOrders } from '../slices/thunks';

const Layout = (props : any) => {
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(fetchDraftOrders());
    }, [dispatch]);

    return (
        <React.Fragment>
            <Header/>
            <Alert/>
            <PWAInstallBanner/>
            <ShopLocationBanner/>
            <div className="page-content-wrapper">
                {props.children}
            </div>
            <InternetStatus/>
            <Footer/>
            <FloatingOrderButton/>
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);
